import { ErrorModel } from '../../../models/ComnModel';

export interface DronState {
  list: DronData[] | undefined;
  count: number | 0;
  detail: DronData | undefined;
  searchParams: string | '';
  selectData: SelectData | undefined;
  listIdntf: IdntfData[] | undefined;
  idntfCount: number | 0;
  isRefreshIdntf: boolean | false;
  page: number | 1;
  total: number | 0;
}

export interface SelectData {
  groupId: string;
  groupNm: string;
}

export interface DronData {
  groupId: string;
  arcrftSno: number;
  arcrftHght: number;
  arcrftLngth: number;
  arcrftModelNm: string;
  arcrftTypeCd: string;
  arcrftWdth: number;
  arcrftWght: number;
  cameraYn: string;
  createDt: Date;
  createUserId: string;
  insrncYn: string;
  prdctCmpnNm: string;
  prdctDate: Date;
  prdctNum: string;
  takeoffWght: number;
  updateDt: Date;
  updateUserId: string;
  imageUrl: string;
  wghtTypeCd: string;
  idntfNum: string;
  newIdntfNum: string;
  idntfTypeCd: string;
  ownerSno: number;
  ownerNm: string;
  hpno: string;
  telno: string;
  useYn: string;
  file: FileList;
}

export interface IdntfData {
  idntfNum: string;
  newIdntfNum: string;
  isSave: boolean;
  updateDt: Date;
  createDt: Date;
  cstmrSno: number;
}

export const initDron = {
  list: undefined,
  count: 0,
  detail: undefined,
  searchParams: '',
  selectData: undefined,
  listIdntf: undefined,
  idntfCount: 0,
  isRefreshIdntf: false,
  page: 1,
  total: 0
};
